import { IAggregator } from 'src/types/aggregator.types';
import { IVenue, IChannel } from 'src/types/venue.types';
import { IChannelValues } from 'src/types/venueForm.types';

const createChannelsInitialValues = (venue: IVenue, aggregators: IAggregator[]): IChannelValues => {
  const channels = {};
  aggregators.forEach((aggregator: IAggregator) => {
    const currentValue = venue?.channels.find((channel: IChannel) => channel.channelId === aggregator.aggregatorId);

    channels[aggregator.aggregatorId] = {
      externalBrandId: currentValue?.externalBrandId ?? null,
      externalId: currentValue?.externalId ?? null,
      pkVenueExternalIdentifierId: currentValue?.pkVenueExternalIdentifierId ?? null,
    };
  });

  return channels;
};

export default createChannelsInitialValues;
